export default __webpack_public_path__ + "static/media/img1.08bf1787.png";